<template>
  <div class="has-background-white">
    <section
      class="is-flex is-flex-direction-column content-center gap-2 has-padding-top-0-mobile has-padding-bottom-0-mobile has-padding-right-0-mobile has-padding-left-0-mobile"
    >
      <div
        class="gradient-orange is-flex is-flex-direction-column gap-1 has-padding-top-55-desktop has-padding-bottom-55-desktop has-padding-top-25-mobile has-padding-bottom-25-mobile has-padding-right-25-mobile has-padding-left-25-mobile"
      >
        <b class="has-text-centered is-size-3"
          >Get the Insights of Jobseeker Availability</b
        >
        <p class="has-text-centered">
          Discover valuable insights on jobseeker availability, elevate your
          recruitment decisions seamlessly.
        </p>
      </div>
      <validation-observer ref="observer" class="container">
        <div
          class="columns content-center align-center is-flex is-flex-wrap mx-5"
        >
          <div
            class="column pb-0 pr-0"
            :class="screen === 'mobile' ? 'is-12' : 'is-3'"
          >
            <validation-provider
              v-slot="{ errors }"
              :name="$t('Job Type')"
              rules="required"
            >
              <vue-auto-complete
                v-model="jobCategory"
                :key="jobCategoryKey"
                item-text="name"
                item-value="slug"
                endpoint="/api/v1/common/job-categories"
                extra-input-class="is-small mb-0"
                :placeholder="$t('Select Job Category')"
                :showDropDownIcon="true"
                :class="{
                  'is-danger': errors.length || fieldErrors.jobCategory
                }"
                :error="!!(errors.length || fieldErrors.jobCategory)"
                :extraFilter="{ level: 3 }"
              ></vue-auto-complete>
              <p v-if="errors" class="field-error help is-danger mt-0">
                {{ errors[0] || get(fieldErrors, 'jobCategory') }}
              </p></validation-provider
            >
          </div>
          <div
            class="column pb-0 pr-0"
            :class="screen === 'mobile' ? 'is-12' : 'is-3'"
          >
            <validation-provider
              v-slot="{ errors }"
              :name="$t('District')"
              :rules="city.length === 0 ? 'required' : ''"
            >
              <vue-auto-complete
                :key="districtKey"
                v-model="district"
                endpoint="/api/v1/common/district/"
                :item-text="$i18n.locale == 'ne' ? 'name_ne' : 'name'"
                extra-input-class="is-small"
                :placeholder="$t('District')"
                from="business"
                item-value="id"
                :showDropDownIcon="true"
                :class="{
                  'is-danger': errors.length || fieldErrors.district
                }"
                :error="!!(errors.length || fieldErrors.district)"
              ></vue-auto-complete>
              <p v-if="errors" class="field-error help is-danger mt-0">
                {{ errors[0] || get(fieldErrors, 'district') }}
              </p>
            </validation-provider>
          </div>
          <div
            class="column pb-0 pr-0"
            :class="screen === 'mobile' ? 'is-12' : 'is-3'"
          >
            <validation-provider
              v-slot="{ errors }"
              :name="$t('City')"
              :rules="district.length === 0 ? 'required' : ''"
            >
              <vue-auto-complete
                :key="cityKey"
                v-model="city"
                endpoint="/api/v1/common/cities/"
                :extra-filter="{
                  district: district === undefined ? '' : district
                }"
                :item-text="$i18n.locale == 'ne' ? 'name_ne' : 'name'"
                extra-input-class="is-small"
                :placeholder="$t('Municipality / VDC')"
                item-value="id"
                filter-by="default_name"
                :class="{
                  'is-danger': errors.length || fieldErrors.city
                }"
                :showDropDownIcon="true"
                :error="!!(errors.length || fieldErrors.city)"
              ></vue-auto-complete>
              <p v-if="errors" class="field-error help is-danger mt-0">
                {{ errors[0] || get(fieldErrors, 'city') }}
              </p>
            </validation-provider>
          </div>
          <div>
            <button
              class="pa-3 ml-3 is-flex align-center mb-2 height-1rem has-background-white outline rounded-10 pointer"
              :disabled="disabled"
              @click="clear()"
            >
              {{ $t('Clear all') }}
            </button>
          </div>
        </div></validation-observer
      >
      <button
        v-if="!showJobseekerData"
        id="btn-search"
        :class="loading ? 'is-loading' : ''"
        class="button rounded is-jobseeker margin-left-auto margin-right-auto"
        @click="searchJobSeekerData()"
        v-text="$t('View Insights')"
      ></button>
    </section>
    <section
      class="container"
      :class="screen === 'mobile' ? 'px-3 mt-10' : 'section-padding'"
    >
      <div :class="screen === 'mobile' ? '' : ''">
        <div
          v-if="showJobseekerData"
          class="border-brown container rounded-10 has-margin-right-10-mobile has-margin-left-10-mobile"
        >
          <div
            class="is-flex is-flex-direction-column gap-1 content-center margin-left-auto margin-right-auto relative"
          >
            <p v-if="Object.keys(response).length" class="has-text-left pr-5">
              <span
                style="
                  position: absolute;
                  margin-bottom: 0.7rem;
                  left: 1rem;
                  bottom: 0;
                "
              >
                {{ $t('Total Jobseeker') }}:
                <span class="has-text-weight-bold">{{
                  response.total_jobseekers
                }}</span>
              </span>
            </p>
            <div
              class="has-text-centered container has-text-weight-semibold is-size-5 absolute position-cook"
            >
              {{ response.category || '-' }}
            </div>
          </div>

          <div
            v-if="showJobseekerData && loading === false"
            class="columns is-multiline is-centered pa-4"
          >
            <div class="column is-12-mobile is-6-tablet is-3-desktop">
              <div
                class="container outline is-shadowless rounded-10 mb-0 text-14 px-3 py-2"
              >
                <span class="has-text-weight-bold mt-6">{{
                  $t('Gender')
                }}</span>
                <div class="DoughnutChart-container">
                  <DoughnutChart
                    class="signup-block"
                    :chart-data="chartGenderData"
                    :options="options"
                  ></DoughnutChart>
                </div>
                <table class="table signup-block">
                  <thead>
                    <tr>
                      <th>{{ $t('Group') }}</th>
                      <th>{{ $t('Count') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(count, range) in gender || []" :key="range">
                      <td>
                        <li>{{ $t(range) || '-' }}</li>
                      </td>
                      <td class="has-text-weight-bold">{{ count || 0 }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="column is-12-mobile is-6-tablet is-3-desktop">
              <div
                class="container outline is-shadowless rounded-10 mb-0 text-14 px-3 py-2"
              >
                <span class="has-text-weight-bold">{{ $t('Age') }}</span>
                <div class="DoughnutChart-container">
                  <DoughnutChart
                    class="signup-block"
                    :chart-data="chartAgeData"
                    :options="options"
                  ></DoughnutChart>
                </div>
                <table class="table signup-block">
                  <thead>
                    <tr>
                      <th>{{ $t('Group') }}</th>
                      <th>{{ $t('Count') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(count, range) in age || []" :key="range">
                      <td>
                        <li>{{ $t(range) || '-' }}</li>
                      </td>
                      <td class="has-text-weight-bold">{{ count || 0 }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="column is-12-mobile is-6-tablet is-3-desktop">
              <div
                class="container outline is-shadowless rounded-10 mb-0 text-14 px-3 py-2"
              >
                <span class="has-text-weight-bold">{{ $t('Location') }}</span>
                <div class="DoughnutChart-container">
                  <DoughnutChart
                    class="signup-block"
                    :chart-data="chartLocationData"
                    :options="options"
                  ></DoughnutChart>
                </div>
                <table class="table signup-block">
                  <thead>
                    <tr>
                      <th>{{ $t('Group') }}</th>
                      <th class="has-text-weight-bold">{{ $t('Count') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(count, range) in location || []" :key="range">
                      <td>
                        <li>
                          {{
                            $i18n.locale === 'en' ? count.name : count.nameNe
                          }}
                        </li>
                      </td>
                      <td class="has-text-weight-bold">
                        {{ count.count || 0 }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="column is-12-mobile is-6-tablet is-3-desktop">
              <div
                class="container outline is-shadowless rounded-10 mb-0 text-14 px-3 py-2"
              >
                <span class="has-text-weight-bold">{{ $t('Education') }}</span>
                <div class="DoughnutChart-container">
                  <DoughnutChart
                    class="signup-block"
                    :chart-data="chartEducationData"
                    :options="options"
                  ></DoughnutChart>
                </div>
                <table class="table signup-block">
                  <thead>
                    <tr>
                      <th>{{ $t('Group') }}</th>
                      <th>{{ $t('Count') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(count, range) in education || []" :key="range">
                      <td>
                        <li>{{ $t(count.name) || '-' }}</li>
                      </td>
                      <td class="has-text-weight-bold">
                        {{ count.count || 0 }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div
            v-else-if="Object.keys(jobCategory).length >= 1 && loading === true"
          >
            <vue-no-data :loading="loading"></vue-no-data>
          </div>

          <div
            class="is-flex is-flex-wrap content-center mt-5 gap-1"
            :class="screen === 'mobile' ? 'mx-6' : ''"
          >
            <div
              v-for="jobseeker in jobseekerList"
              :key="jobseeker.id"
              class="box outline is-shadowless mb-0 column is-12-mobile is-6-tablet is-4-desktop"
            >
              <p>{{ jobseeker.name }}</p>
              <p>
                Location:
                <span class="has-text-weight-semibold">{{
                  jobseeker.location
                }}</span>
                Experience:
                <span class="has-text-weight-semibold">{{
                  jobseeker.experience
                }}</span>
              </p>
              <p>
                Salary:
                <span class="has-text-weight-semibold">{{
                  jobseeker.salary
                }}</span>
              </p>
            </div>
          </div>

          <button
            id="btn-post-a-job-about"
            class="position-post-a-job button rounded is-employer margin-right-auto margin-left-auto"
            :class="screen === 'mobile' ? 'position-post-a-job-mobile' : ''"
            @click="gotoJobPost()"
          >
            {{ $t('Post Job') }}
          </button>
        </div>
      </div>
    </section>
    <section
      class="container d-grid gap-1 available-employer"
      :class="screen === 'mobile' ? 'px-2 py-7' : 'section-padding'"
    >
      <h3
        class="service is-size-4 is-size-3-mobile has-text-weight-bold has-text-centered mb-5"
      >
        {{ $t('You are looking for') }}
      </h3>
      <div
        class="columns gap-1"
        :class="
          screen === 'mobile'
            ? 'columns is-flex is-flex-wrap gap-1 ma-2'
            : 'pr-10 mx-2'
        "
      >
        <div class="column is-3 box rounded-10 lift-shadow pa-4 mb-0">
          <div
            class="has-text-centered is-employer d-flex d-placeitem d-placecontent vue-icon vue-icon-background signup-block mb-3 pa-4"
          >
            <vue-icon-base
              height="16"
              width="16"
              :path="$options.icons[$kc('uni-cloud-download')]"
            ></vue-icon-base>
          </div>
          <p class="has-text-centered">
            {{ $t('Create an employer profile') }}
          </p>
        </div>
        <div class="column is-3 box rounded-10 lift-shadow pa-4 mb-0">
          <div
            class="has-text-centered d-flex d-placeitem d-placecontent vue-icon vue-icon-background signup-block mb-3 pa-4"
          >
            <vue-icon-base
              height="16"
              width="16"
              :path="$options.icons[$kc('uni-file-info-alt')]"
            ></vue-icon-base>
          </div>
          <p class="has-text-centered">
            {{ $t('Click on the post-job & fill details') }}
          </p>
        </div>
        <div class="column is-3 box rounded-10 lift-shadow pa-4 mb-0">
          <div
            class="has-text-centered d-flex d-placeitem d-placecontent vue-icon vue-icon-background signup-block mb-3 pa-4"
          >
            <vue-icon-base
              height="16"
              width="16"
              :path="$options.icons[$kc('uni-cloud-meatball')]"
            ></vue-icon-base>
          </div>
          <p class="has-text-centered">
            {{ $t('Get the job application') }}
          </p>
        </div>
        <div class="column is-3 box rounded-10 lift-shadow pa-4">
          <div
            class="has-text-centered d-flex d-placeitem d-placecontent vue-icon vue-icon-background signup-block mb-3 pa-4"
          >
            <vue-icon-base
              class="has-text-centered"
              height="16"
              width="16"
              :path="$options.icons[$kc('uni-user-check')]"
            ></vue-icon-base>
          </div>
          <p class="has-text-centered">
            {{ $t('Select the preferred worker') }}
          </p>
        </div>
      </div>
    </section>
    <section
      class="container"
      :class="screen === 'mobile' ? 'px-3 py-7' : 'section-padding'"
    >
      <div
        class="is-flex is-flex-direction-column content-center gap-1 outline rounded-10 vue-icon-background pa-8"
      >
        <b class="is-size-4 has-text-centered">
          Quick & Easy Job Posting Service − Get Quality Applications
        </b>
        <p class="has-text-centered px-2">
          As a distinguished national employment platform of Nepal, we take
          pride in empowering employers like you by connecting you with a
          diverse pool of skilled and motivated job seekers. We understand the
          importance of finding the right talent to drive your organization's
          success. Our platform is designed to seamlessly bridge the gap between
          employers and job seekers, providing you with a powerful tool to
          source top-notch candidates efficiently.
          <br />
          <br />
          Elevate your recruitment process and contribute to the growth of your
          business by posting your job openings on Rojgari.
        </p>
        <button
          id="btn-post-a-job-about"
          class="button rounded is-employer margin-right-auto margin-left-auto"
          @click="gotoJobPost()"
        >
          {{ $t('Post a Job Today') }}
        </button>
      </div>
    </section>
    <section
      class="container pa-0 is-flex is-flex-direction-column content-center"
      :class="screen === 'mobile' ? 'px-2 py-7' : 'section-padding'"
    >
      <top-employer
        showDifferentTitle="Our Happy Clients"
        :class="screen === 'mobile' ? 'px-2 py-7' : 'section-padding'"
      ></top-employer>
    </section>
    <section
      class="container"
      :class="screen === 'mobile' ? 'px-2 py-7' : 'section-padding'"
    >
      <popular-questions></popular-questions>
    </section>
    <section class="has-background-black">
      <section
        class="container"
        :class="screen === 'mobile' ? 'px-2 py-7' : 'section-padding pa-8'"
      >
        <div class="has-background-white padding-80px has-background-black">
          <div class="container">
            <div
              class="is-flex align-center content-center gap-2 tiro-font"
              :class="screen === 'mobile' ? 'is-flex-direction-column' : ''"
            >
              <div class="has-text-white is-size-4">
                {{ $t('Download Now') }}
              </div>
              <a
                id="btn-download-android"
                class="pointer height-60px"
                href="https://play.google.com/store/apps/details?id=com.rojgaripasal.rojgariapp"
                target="_blank"
              >
                <img
                  src="/images/account/android_download.png"
                  class="height-60px"
                />
              </a>
              <a
                id="btn-download-apple"
                class="pointer height-60px"
                href="https://apps.apple.com/us/app/rojgari/id1493964641?ign-mpt=uo%3D2"
                target="_blank"
              >
                <img
                  src="/images/account/apple_download.png"
                  class="height-60px"
                />
              </a>
            </div>
          </div>
        </div>
      </section>
    </section>
  </div>
</template>
<script>
import formMixin from '@/mixins/veeValidate'
import VueIconBase from '@/components/Commons/VueIconBase'
import {
  uniCircle,
  uniCloudDownload,
  uniFileInfoAlt,
  uniCloudMeatball,
  uniUserCheck
} from '@/helpers/icons'
import VueAutoComplete from '@/components/Commons/VueAutoComplete'
import DoughnutChart from '@/components/Charts/DoughnutChart.vue'
import { mapGetters } from 'vuex'
import VueNoData from '@/components/Commons/VueNoData'
import TopEmployer from '~/components/Homepage/TopEmployer.vue'
import PopularQuestions from '~/components/Faq/PopularQuestions.vue'
export default {
  components: {
    VueAutoComplete,
    DoughnutChart,
    VueIconBase,
    TopEmployer,
    PopularQuestions,
    VueNoData
  },
  mixins: [formMixin],
  icons: {
    uniCircle,
    uniCloudDownload,
    uniFileInfoAlt,
    uniCloudMeatball,
    uniUserCheck
  },
  data() {
    const options = {
      legend: {
        display: false
      },
      responsive: true,
      maintainAspectRatio: false,
      animation: {
        animateRotate: true
      }
    }
    return {
      jobCategory: '',
      jobCategoryKey: 1,
      districtKey: 1,
      district: '',
      districtCounter: 0,
      cityCounter: 0,
      cityKey: 1,
      city: '',
      jobseekerList: {},
      showJobseekerData: false,
      loading: false,
      chartAgeData: {},
      chartGenderData: {},
      chartLocationData: {},
      chartEducationData: {},
      options,
      showGenderChart: true,
      showAgeChart: true,
      showLocationChart: true,
      showEducationChart: true,
      age: {},
      ageLabel: [],
      ageDataset: [],
      gender: {},
      genderLabel: [],
      genderDataset: [],
      education: {},
      educationLabel: [],
      educationDataset: [],
      location: {},
      locationLabel: [],
      locationDataset: [],
      response: {},
      disabled: true
    }
  },
  computed: {
    ...mapGetters({
      screen: 'getScreen'
    })
  },
  watch: {
    jobCategory: {
      handler(val) {
        if (val.length >= 1) {
          this.disabled = false
          this.searchJobSeekerData()
        }
      },
      deep: true
    },
    district: {
      handler(val) {
        if (val) {
          this.disabled = false
          this.searchJobSeekerData()
        }
      },
      deep: true
    },
    city: {
      handler(val) {
        if (val) {
          this.disabled = false
          this.searchJobSeekerData()
        } else {
          this.showJobseekerData = false
        }
      },
      deep: true
    },
    showGenderChart: {
      handler() {
        this.chartGenderData = {
          labels: this.genderLabel,
          datasets: [
            {
              backgroundColor: ['#e48228', '#eb9f36', '#f0a64a'],
              data: this.genderDataset
            }
          ]
        }
      },
      deep: true
    },
    showAgeChart: {
      handler() {
        this.chartAgeData = {
          labels: this.ageLabel,
          datasets: [
            {
              backgroundColor: ['#e48228', '#eb9f36', '#f0a64a'],
              data: this.ageDataset
            }
          ]
        }
      },
      deep: true
    },
    showLocationChart: {
      handler() {
        this.chartLocationData = {
          labels: this.locationLabel,
          datasets: [
            {
              backgroundColor: [
                '#e48228',
                '#eb9f36',
                '#f0a64a',
                '#fac172',
                '#ffc286',
                '#ffd09a',
                '#ffdcae',
                '#ffe0c2',
                '#ffe6d6',
                '#ffecd9'
              ],
              data: this.locationDataset
            }
          ]
        }
      },
      deep: true
    },
    showEducationChart: {
      handler() {
        this.chartEducationData = {
          labels: this.educationLabel,
          datasets: [
            {
              backgroundColor: [
                '#e48228',
                '#eb9f36',
                '#f0a64a',
                '#fac172',
                '#ffc286',
                '#ffd09a',
                '#ffdcae',
                '#ffe0c2',
                '#ffe6d6',
                '#ffecd9'
              ],
              data: this.educationDataset
            }
          ]
        }
      },
      deep: true
    }
  },
  methods: {
    clear() {
      this.disabled = true
      this.jobCategory = ''
      this.district = ''
      this.city = ''
      this.showJobseekerData = false
    },
    async searchJobSeekerData() {
      this.showJobseekerData = false
      if (await this.validateAllFields()) {
        this.loading = true
        this.$axios
          .$get(
            `/api/v1/jobseekers/insights/?district=${this.district}&locations=${this.city}&categories=${this.jobCategory}&is_not_referrer=true`
          )
          .then(resp => {
            this.response = resp
            this.age = this.response.age
            this.ageLabel = Object.keys(this.age)
            this.ageDataset = Object.values(this.age)
            this.gender = this.response.gender
            this.genderLabel = Object.keys(this.gender)
            this.genderDataset = Object.values(this.gender)
            this.education = this.response.educations
            this.educationLabel = this.education.map(({ name }) => name)
            this.educationDataset = this.education.map(({ count }) => count)
            this.location = this.response.locations
            this.locationLabel = this.location.map(({ name }) => name)
            this.locationDataset = this.location.map(({ count }) => count)
            this.showGenderChart = !this.showGenderChart
            this.showAgeChart = !this.showAgeChart
            this.showLocationChart = !this.showLocationChart
            this.showEducationChart = !this.showEducationChart
            this.loading = false
            this.showJobseekerData = true
          })
          .catch(() => {
            this.loading = false
            this.showJobseekerData = true
          })
      }
    },
    gotoJobPost() {
      if (this.$auth.loggedIn && this.$auth.user.employer_profile) {
        if (this.$auth.user.has_filled_initial_form) {
          if (
            this.$auth.user.related_organizations.length &&
            this.$auth.user.is_purchase_available
          ) {
            this.$nuxt.$emit('openinitialform')
          } else if (!this.$auth.user.is_purchase_available) {
            this.$router.push(
              this.localePath({
                name: 'pricing'
              })
            )
          } else {
            this.setDialog({ display: true, type: 'details' })
            this.notifyError(this.$t('Initial profile form not filled'))
          }
        } else {
          this.setDialog({ display: true, type: 'details' })
          this.notifyError(this.$t('Initial profile form not filled'))
        }
      } else {
        this.setDialog({
          display: true,
          type: 'employer-sign-in',
          extraInfo: 'employer-sign-in'
        })
        this.notifyError(
          this.$t('You need to login as an employer to post a job.')
        )
      }
    }
  }
}
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Mukta:wght@200;300;400;500;600;700;800&display=swap');

section {
  font-family: 'Mukta', sans-serif;
}

.section-padding {
  padding-left: 80px;
  padding-right: 80px;
  padding-top: 80px;
  padding-bottom: 80px;
}

.padding-48px {
  padding: 48px;
}

.position-cook {
  top: -1rem;
  left: 50%;
  transform: translate(-50%, 0%);
  background: white;
  padding: 0 1rem;
}

.position-post-a-job {
  top: 1.2rem;
  right: -44.5%;
  padding: 0 1rem;
}
.position-post-a-job-mobile {
  top: 1.3rem;
  right: -33%;
  padding: 0 1rem;
}
.gradient-orange {
  background: linear-gradient(
      0deg,
      rgba(249, 157, 30, 0.3) -27.74%,
      rgba(249, 157, 30, 0) 69.34%
    ),
    url('/images/HomepageImages/new-homepage.png'),
    #f7f7f7 100% / cover no-repeat;
}
.vue-icon-background {
  background-color: #ffeeda;
}
.vue-icon {
  width: max-content;
  border-radius: 11px;
  aspect-ratio: 1/1;
}
.height-1rem {
  height: 1rem;
}
canvas {
  width: 150px;
  height: 150px;
}
</style>
